export default "__VITE_ASSET__1D1YbGpT__"